var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import FORMATS from '../../../../config/formats';
import Component from 'vue-class-component';
import { namespace, State } from 'vuex-class';
import moment from 'moment';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { DateUtility } from 'packages/utilities/DateUtility';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { User } from 'packages/users/User';
import Icon from 'common/UIToolKit/Icon.vue';
import Avatar from 'common/UIToolKit/Avatar.vue';
import IndeterminateCircle from '../../loaders/IndeterminateCircle.vue';
import Vue from 'vue';
import { container } from 'tsyringe';
import EmptyState from 'ui/v1/EmptyState.vue';
import { TalentComment } from 'packages/talent/entities/TalentComment';
import { CandidateCategory } from 'packages/v3/jobs/Candidate';
import CogMenu from 'ui/v1/controls/CogMenu.vue';
import { LinkifyService } from 'services/LinkifyService';
import { FeatureConfiguration } from 'packages/features/FeatureConfiguration';
import { Job } from 'packages/v3/jobs/Job';
var talentComment = namespace('talentCard/talentCommentState');
var jobs = namespace('jobs');
var ChatBox = /** @class */ (function (_super) {
    __extends(ChatBox, _super);
    function ChatBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.message = '';
        _this.editingMessageBody = '';
        _this.hoveringOnId = null;
        _this.editingMessageId = null;
        _this.authenticator = container.resolve(Authenticator);
        _this.linkifyService = container.resolve(LinkifyService);
        _this.chatContents = [];
        _this.interval = null;
        return _this;
    }
    Object.defineProperty(ChatBox.prototype, "jobId", {
        get: function () {
            var _a;
            return parseInt((_a = this.$route.params) === null || _a === void 0 ? void 0 : _a.jobId, 10) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChatBox.prototype, "userId", {
        get: function () {
            return parseInt(this.authenticator.currentUserId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChatBox.prototype, "candidate", {
        get: function () {
            var _this = this;
            return this.candidates.find(function (candidate) { return candidate.talent.id === _this.talentId; });
        },
        enumerable: false,
        configurable: true
    });
    ChatBox.prototype.messageActions = function (message) {
        var _this = this;
        return [
            {
                title: this.$t('common.edit'),
                action: function () {
                    _this.editingMessageId = message.id;
                    _this.editingMessageBody = message.body;
                    _this.$nextTick(function () {
                        // Focuses JDS Text field
                        try {
                            _this.$refs["editInput-" + message.id][0].$el.children[0].focus();
                        }
                        catch (e) {
                            //
                        }
                    });
                },
            },
        ];
    };
    ChatBox.prototype.sendMessage = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        if (!this.message) {
            return;
        }
        try {
            this.postComment({
                talentId: this.talentId,
                body: this.message,
                jobId: this.jobId,
            });
        }
        catch (e) {
            throw e;
        }
        this.editingMessageId = null;
        this.message = '';
        if (this.candidate) {
            this.candidate.totalComments += 1;
        }
        this.$posthog.capture('Comment added', {
            category: CandidateCategory[(_b = (_a = this.candidate) === null || _a === void 0 ? void 0 : _a.category) !== null && _b !== void 0 ? _b : 0],
            pipelineStageType: (_d = (_c = this.job.stages) === null || _c === void 0 ? void 0 : _c.find(function (stage) { var _a; return stage.id === ((_a = _this.candidate) === null || _a === void 0 ? void 0 : _a.pipelineStage); })) === null || _d === void 0 ? void 0 : _d.type,
            timeCreated: (_e = this.candidate) === null || _e === void 0 ? void 0 : _e.createdAt,
            hoursInFunnel: (_f = this.candidate) === null || _f === void 0 ? void 0 : _f.hoursInFunnel,
        });
        this.$nextTick(function () { return _this.scrollToBottom(); });
    };
    ChatBox.prototype.editMessage = function (message) {
        this.editComment({
            talentId: this.talentId,
            body: message.body,
            commentId: message.id,
            jobId: this.jobId,
        });
        this.editingMessageId = null;
    };
    ChatBox.prototype.cancelEditing = function (message) {
        this.editingMessageId = null;
        message.body = this.editingMessageBody;
    };
    ChatBox.prototype.deleteMessage = function (message) {
        var _this = this;
        this.confirmMessageDeletionModal.confirm()
            .then(function () {
            try {
                _this.deleteComment({
                    talentId: _this.talentId,
                    commentId: message.id,
                    jobId: _this.jobId,
                });
            }
            catch (e) {
                throw e;
            }
            _this.candidate.totalComments -= 1;
        })
            .catch(function () { return null; });
    };
    ChatBox.prototype.scrollToBottom = function () {
        var _this = this;
        var messageBox = this.$refs.messageBox;
        var height = (messageBox) ? messageBox.scrollTop : 0;
        this.interval = window.setInterval(function () {
            height += (2 + (height / 50));
            if (!messageBox || height >= messageBox.scrollHeight) {
                _this.stopScrolling();
                return;
            }
            messageBox.scrollTop = height;
        }, 0.5);
    };
    ChatBox.prototype.stopScrolling = function () {
        clearInterval(this.interval);
    };
    ChatBox.prototype.formatDate = function (date) {
        return new DateUtility(date).format(FORMATS.DATE.FULL);
    };
    ChatBox.prototype.processMessages = function () {
        var _this = this;
        this.chatContents = [];
        if (this.comments.length === 0) {
            return;
        }
        var content;
        this.comments.forEach(function (message, index) {
            var _a;
            var isFirst = index === 0;
            var previousMessage = !isFirst ? _this.comments[index - 1] : new TalentComment();
            /*
             * Check if need to reset the content object before injecting more messages to it,
             * eg. different author or day requires a new block to group the content into
             */
            if (isFirst ||
                (message.author !== previousMessage.author) ||
                new DateUtility(message.createdAt).format('d') !== new DateUtility(previousMessage.createdAt).format('d')) {
                if (!isFirst) {
                    _this.chatContents.push(content);
                }
                content = {};
                content.id = index;
                content.date = message.createdAt;
                content.messages = [];
                content.messages.push(message);
                content.createdBy = (_a = _this.commenters.find(function (commenter) { return commenter.id === message.author; })) !== null && _a !== void 0 ? _a : new User();
            }
            else {
                content.messages.push(message);
            }
        });
        if (content !== undefined) {
            this.chatContents.push(content);
            this.$nextTick(function () { return _this.scrollToBottom(); });
        }
    };
    ChatBox.prototype.storeMessageInLocalstorage = function (message) {
        localStorage.setItem(this.storageKey(), message);
    };
    ChatBox.prototype.loadDraftComment = function () {
        var _a;
        this.message = (_a = localStorage.getItem(this.storageKey())) !== null && _a !== void 0 ? _a : '';
    };
    ChatBox.prototype.storageKey = function () {
        return "comments." + this.talentId + ".draft";
    };
    var _a, _b;
    __decorate([
        State,
        __metadata("design:type", typeof (_a = typeof FeatureConfiguration !== "undefined" && FeatureConfiguration) === "function" ? _a : Object)
    ], ChatBox.prototype, "features", void 0);
    __decorate([
        talentComment.State,
        __metadata("design:type", Boolean)
    ], ChatBox.prototype, "loading", void 0);
    __decorate([
        talentComment.State,
        __metadata("design:type", Array)
    ], ChatBox.prototype, "comments", void 0);
    __decorate([
        talentComment.State,
        __metadata("design:type", Array)
    ], ChatBox.prototype, "commenters", void 0);
    __decorate([
        talentComment.Action,
        __metadata("design:type", Function)
    ], ChatBox.prototype, "postComment", void 0);
    __decorate([
        talentComment.Action,
        __metadata("design:type", Function)
    ], ChatBox.prototype, "editComment", void 0);
    __decorate([
        talentComment.Action,
        __metadata("design:type", Function)
    ], ChatBox.prototype, "deleteComment", void 0);
    __decorate([
        jobs.State,
        __metadata("design:type", Array)
    ], ChatBox.prototype, "candidates", void 0);
    __decorate([
        jobs.State,
        __metadata("design:type", typeof (_b = typeof Job !== "undefined" && Job) === "function" ? _b : Object)
    ], ChatBox.prototype, "job", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], ChatBox.prototype, "confirmMessageDeletionModal", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Number)
    ], ChatBox.prototype, "talentId", void 0);
    __decorate([
        Watch('comments', { deep: true, immediate: true }),
        Watch('commenters', { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ChatBox.prototype, "processMessages", null);
    __decorate([
        Watch('message'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ChatBox.prototype, "storeMessageInLocalstorage", null);
    __decorate([
        Watch('talentId', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ChatBox.prototype, "loadDraftComment", null);
    ChatBox = __decorate([
        Component({
            components: {
                CogMenu: CogMenu,
                EmptyState: EmptyState,
                IndeterminateCircle: IndeterminateCircle,
                Icon: Icon,
                Avatar: Avatar,
            },
            filters: {
                messageDate: function (value) {
                    return moment(value).format('HH:mm');
                },
            },
            beforeDestroy: function () {
                var _this = this;
                if (this.editingMessageId) {
                    var notSavedEditComment = this.comments.find(function (comment) { return comment.id === _this.editingMessageId; });
                    notSavedEditComment.body = this.editingMessageBody;
                }
            },
        })
    ], ChatBox);
    return ChatBox;
}(Vue));
export default ChatBox;
